const colors = {
  // Need to organise Getolo (all vertical) colors

  // getolo - main
  PROFESSIONAL_BLUE: '#003264',
  VITALIZED_BLUE: '#3458ff',

  // getolo - supporting
  CLEAR_SKY_BLUE: '#bfdaff',
  PRODUCT_BLUE: '#7c95ae',
  PROFESSIONAL_LIGHT_BLUE: '#335b83',
  SKY_BLUE: '#97c2ff',
  ULTRA_CLEAR_LIGHT_BLUE: '#f3f9fe',

  // getolo - neutral
  BLACK: '#000',
  GRAY: '#666',
  LIGHT_GRAY: '#e7e7e8',
  ULTRA_LIGHT_GRAY: '#f7f7f7',
  WHITE: '#fff',

  // getolo - additional
  ERROR_RED: '#c91d1d',
  SUCCESS_GREEN: '#448000',

  // dentolo - main
  VITALIZED_GREEN: '#32ff96',
  CLEAR_LIGHT_GREEN: '#eafff4',
  LOVELY_ROSE: '#fac8d2',

  // dentolo - additional
  CLEAR_LIGHT_BLUE: '#dff1fd',

  // petolo - main
  VITALIZED_ORANGE: '#ffa445',

  // petolo - additional
  CLEAR_LIGHT_ORANGE: '#fff4d9',

  // vitolo - main
  VIBRANT_LIGHT_VIOLET: '#cbb7ff',

  // vitolo - supporting
  CLEAR_LIGHT_VIOLET: '#f5f2ff',
  DUSTY_BLUE: '#6675b1',
  LAVENDER_INDIGO: '#956cff',
  PERIWINKLE: '#d1cdff',
  ULTRA_CLEAR_LIGHT_VIOLET: '#fcfbff',

  // vitolo - additional contrasting highlights
  LIGHT_PEACH: '#fed5b7',
  ULTRA_LIGHT_PEACH: '#feeadb',

  // vitolo - additional highlights (2%)
  SPRING_GREEN: '#3af396',
  LIGHT_SPRING_GREEN: '#a5ffd2',

  // da-direkt colors
  DA_DIREKT_BACKGROUND_1: '#f2f5f7',
  DA_DIREKT_BORDER_LINES: '#768da5',
  DA_DIREKT_BRIGHT_ORANGE: '#ff5e2e', // rgb: `255, 94, 46`
  DA_DIREKT_BUTTON_HOVER: '#e64c21',
  DA_DIREKT_BUTTON_ACTIVE: '#cc431c',
  DA_DIREKT_COLOR_1: '#bfccd8', // Light gray blue
  DA_DIREKT_DARK_BLUE_80: '#335B83',
  DA_DIREKT_ERROR_RED: '#b00020',
  DA_DIREKT_SUCCESS: '#2e7d32',
  DA_DIREKT_HOVER_BACK_BUTTON: '#005fa3',
  DA_DIREKT_GRAY_2: '#595959',
  DA_DIREKT_GRAY_3: '#767676',
  DA_DIREKT_VISUAL_BRAND_BLUE: '#0071c8',
  DA_DIREKT_VISUAL_BRAND_ORANGE: '#fb4d18',

  // fressnapf colors
  FRESSNAPF_BACKGROUND_TERTIARY: '#fafcf3',
  FRESSNAPF_HOVER: '#d4e3d5',
  FRESSNAPF_PRIMARY: '#657d12',
  FRESSNAPF_PRIMARY_HOVER: '#196428',
  FRESSNAPF_TEXT_ERROR: '#df2020',
  FRESSNAPF_TEXT_PLACEHOLDER: '#b2b2b2',
  FRESSNAPF_TEXT_PRIMARY: '#464646',
  FRESSNAPF_TEXT_SECONDARY: '#757575',
  FRESSNAPF_YELLOWISH_GREEN_LIGHT: '#c8d86b',

  // fressnapf - old names
  COLOR_FOREST_GREEN: '#196428',
  COLOR_GREYISH_BLACK: '#464646',
  COLOR_LIGHT_ORANGE: '#f7ae83',
  COLOR_YELLOWISH_GREEN: '#819F17',

  // misc colors
  DARK_GREEN: '#0a4c2a',
  DARK_ORANGE: '#ed7800',

  // da + kaufland colors
  DA_KAUFLAND_BLACK: '#424242',
  DA_KAUFLAND_GRAY_1: '#8d8d8d',
  DA_KAUFLAND_GRAY_2: '#949494',
  DA_KAUFLAND_LIGHT_GRAY: '#d9d9d9',
  DA_KAUFLAND_LIGHT_GRAY_2: '#d3d3d3',
  DA_KAUFLAND_GREEN: '#70d159',
  DA_KAUFLAND_RED: '#e10915',
};

export default colors;
